import { cloneElement } from "react";
import classNames from "classnames";
import { icons, iconSizes } from "@/comn/assets/icons";
import { COLOR_TEXT } from "../features/foundation";

export type IconsType = keyof typeof icons;
export type IconSizesType = keyof typeof iconSizes;

export type IconProps = {
    icon: IconsType;
    size?: IconSizesType;
    className?: string;
    onClick?: () => void;
    color?: keyof typeof COLOR_TEXT;
};

export const Icon = (props: IconProps) => {
    const { icon, className, color, onClick, size = "md" } = props;

    if (!icon || !icons[icon]) return null;
    return cloneElement(icons[icon], {
        ...icons[icon].props,
        className: classNames(iconSizes[size], color && COLOR_TEXT[color], className),
        strokeWidth: 2,
        onClick,
    });
};
